module.exports = __webpack_public_path__ + "img/OrdenesCompra.613e3e2e.png";